export const getVoucherStatus = (voucher) => {
  let status = 'Active';

  const now = new Date().getTime();

  if (voucher.expiryDate &&
    new Date(voucher.expiryDate).getTime() < now) {
    status = 'Expired';
  } else if (voucher.activationDate &&
    new Date(voucher.activationDate).getTime() > now) {
    status = 'Not active yet';
  }

  return status;
};
